export enum VariantEnum {
  Event = "event",
  Season = "season",
  Venue = "venue",
}
